import React, { ReactNode } from 'react';
import ReactModal from 'react-modal';
import PrimaryButton from '../buttons/PrimaryButton';
import SecondaryButton from '../buttons/SecondaryButton';

interface IButton {
  text: string | ReactNode;
  onClick: () => void;
  disabled?: boolean;
  className?: string;
}

interface IModalProps {
  title: string;
  description: string | ReactNode;
  primaryButtonProps: IButton;
  secondaryButtonProps?: IButton;
  isOpen: boolean;
  onClose: () => void;
}

function Modal({ title, description, primaryButtonProps, secondaryButtonProps, isOpen, onClose }: IModalProps) {
  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={onClose}
      className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 
             w-[300px] md:w-[700px] sm:w-[500px]
             rounded-lg border-none p-6 sm:p-10 bg-white"
      overlayClassName="fixed inset-0 bg-black/75"
    >
      <h1 className="text-primary-2 text-xl font-bold leading-7! mb-4">{title}</h1>
      <p className="text-md text-primary-2 leading-6! text-pretty">{description}</p>
      <div className="flex max-w-[50%] justify-start gap-4 mt-6">
        <PrimaryButton {...primaryButtonProps}>{primaryButtonProps.text}</PrimaryButton>
        {secondaryButtonProps && (
          <SecondaryButton {...secondaryButtonProps}>{secondaryButtonProps.text}</SecondaryButton>
        )}
      </div>
    </ReactModal>
  );
}

export default Modal;
